import { User } from '@/__generated__/graphql';
import { Google as GoogleIcon, Email as EmailIcon } from '@mui/icons-material';
import MicrosoftIcon from '@mui/icons-material/Microsoft';

export const getHeadCells = () => {
  const fields = [
    'name',
    'email',
    'roleIds',
    'lastLogin',
    'loginType',
    'status',
    'loginCount',
    'isBlocked',
  ] as (keyof User)[];

  const labels = [
    'User Name',
    'Email Address',
    'User Roles',
    'Last Login',
    'Login Type',
    'Status',
    'Login Count',
    '',
  ];

  return fields.map((field, index) => ({
    id: field,
    numeric: false,
    disablePadding: index !== 0,
    label: labels[index],
  }));
};

export const loginIcons = (type: string): JSX.Element => {
  switch (type) {
    case 'google-oauth2':
      return <GoogleIcon sx={{ color: 'action.selected' }} />;
    case 'BP-Azure-AD':
      return <MicrosoftIcon sx={{ color: 'action.selected' }} />;
    default:
      return <EmailIcon sx={{ color: 'action.selected' }} />;
  }
};
